import React from 'react';
import PropTypes from 'prop-types';
import { sanitize } from 'dompurify';
import { isDesktop } from 'bv';
import ExpandableParagraph from './expandable_paragraph';

const collapsedTextLength = 200;

const CopySection = ({
  content,
  title,
}) => (
  <section className="site-copy-section">
    <header className="site-copy-section__header">
      <h2 className="site-copy-section__title bvs-h5">
        {title}
      </h2>
    </header>

    <div className="site-copy-section__content">
      {(isDesktop() || content.length <= collapsedTextLength) ? (
        <span dangerouslySetInnerHTML={{ __html: sanitize(content) }} />
      ) : (
        <ExpandableParagraph text={content} />
      )}
    </div>
  </section>
);

CopySection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default CopySection;
